export const GET_PAYMENTS = 'GET_PAYMENTS';
export const GET_PAYMENT_DETAIL = 'GET_PAYMENT_DETAIL';